import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithGoogle, loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const redirectPath = searchParams.get("redirect") || "/mis-sesiones";

        // New flow: JWT token from Google OAuth callback
        const token = searchParams.get("token");
        if (token) {
          const user = await loginWithToken(token);
          toast.success(`¡Bienvenido/a, ${user.name}!`);
          if (user.role === "admin") {
            navigate("/admin");
          } else if (user.role === "listener") {
            navigate("/listener");
          } else {
            navigate(redirectPath);
          }
          return;
        }

        // Legacy flow: session_id from URL hash (fallback)
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        if (sessionIdMatch) {
          const sessionId = sessionIdMatch[1];
          const user = await loginWithGoogle(sessionId);
          toast.success(`¡Bienvenido/a, ${user.name}!`);
          if (user.role === "admin") {
            navigate("/admin");
          } else if (user.role === "listener") {
            navigate("/listener");
          } else {
            navigate(redirectPath);
          }
          return;
        }

        toast.error("Error de autenticación");
        navigate("/login");
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error("Error al iniciar sesión con Google");
        navigate("/login");
      }
    };

    processAuth();
  }, [loginWithGoogle, loginWithToken, navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-stone-600">Iniciando sesión...</p>
      </div>
    </div>
  );
}
